module.exports = __webpack_public_path__ + "static/1.1.E.5 FORNA PLAN SUBSOL-84e0d3b40787aad70cc7c89306fee593.jpg";